import { Paper, PaperProps } from '@mui/material';
import React, { useState } from 'react';

const PaperWrapper = (props: PaperProps) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <Paper
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      variant={isHover ? 'elevation' : 'outlined'}
      elevation={isHover ? 4 : 0}
      sx={{
        borderRadius: '8px',
        padding: '20px 0px',
        '&:hover': { border: 1, borderColor: 'transparent' },
      }}
      {...props}
    />
  );
};

export default PaperWrapper;
